import React, { useEffect, useMemo, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Creators as GradeCoursesActions } from '../../../../../domain/useCases/getCoursesGradeRecord';
import NotesRecordView from './NotesRecordView';
import XCheckpointManager from '@/core/managers/xcheckpointManager';
import constants from '../../constants';
import GoogleAnalytics from '@/presentation/hooks/useGoogleAnalytics';

const calculateApprovedCredits = (periods = []) =>
  periods.reduce(
    (total: any, period: any) =>
      total +
      period.items.reduce(
        (subTotal: any, course: any) =>
          course.approvalStatus === 'Aprobado'
            ? subTotal + parseFloat(course.credits)
            : subTotal,
        0
      ),
    0
  );

const NotesRecordController = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [registerStart, setRegisteStart] = useState(false);
  const [registerEnd, setRegisteEnd] = useState(false);

  const { plan, progDesc } = useSelector(
    (state: any) => state.profile.data.academic
  );
  const { firstName, lastName, studentCode } = useSelector(
    (state: any) => state.profile.data.profile
  );
  const { data: periods, isLoading: gradesLoading } = useSelector(
    (state: any) => state.getCoursesGradeRecord
  );

  useEffect(() => {
    GoogleAnalytics.writeLog('portal-course-recordNotes', 'course');
    if (!registerStart) {
      XCheckpointManager.registerStart('record de notas');
      setRegisteStart(true);
    }
  }, []);

  useEffect(() => {
    dispatch(GradeCoursesActions.getCoursesGradeRecord());
  }, [dispatch]);

  const handleBack = () => history.push('/cursos');

  const totalApprovedCredits = useMemo(
    () => calculateApprovedCredits(periods || []),
    [periods]
  );

  const studentData = {
    studentName: `${firstName} ${lastName}`,
    studentCode,
    progDesc,
    plan,
    totalApprovedCredits,
    periods: periods || []
  };

  useEffect(() => {
    if (!gradesLoading && !registerEnd) {
      XCheckpointManager.registerEnd('record de notas');
      setRegisteEnd(true);
    }
  }, [gradesLoading]);

  return (
    <NotesRecordView
      handlerBack={handleBack}
      data={studentData}
      subsectionHeader={constants.subsectionHeader}
    />
  );
};

export default NotesRecordController;
